const convertMoney = (original) => {
  const oneBillion = 1000000000
  const oneMillion = 1000000

  if (original > oneBillion) return `${parseFloat((original / oneBillion).toPrecision(3))} tỷ`

  return `${parseFloat((original / oneMillion).toPrecision(3))} triệu`
}

export default convertMoney
